var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExpiredJobPost = function SvgExpiredJobPost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 44,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 20.5,
    r: 19.5,
    fill: "#FFE6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF8080",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M18.638 31.794H12.18",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF8080",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M28.415 27.208v7.75c0 5.167-1.291 6.458-6.458 6.458H9.04c-5.166 0-6.458-1.291-6.458-6.458V22.041c0-5.166 1.292-6.458 6.458-6.458h1.938c1.937 0 2.364.568 3.1 1.55l1.937 2.583c.491.646.775 1.034 2.067 1.034h3.875c5.167 0 6.458 1.291 6.458 6.458Z"
  })));
};
export default SvgExpiredJobPost;